import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToggleFullScreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { AccordionAnchorDirective } from './accordion/accordionanchor.directive';
import { AccordionLinkDirective } from './accordion/accordionlink.directive';
import { AccordionDirective } from './accordion/accordion.directive';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { TitleComponent } from '../layout/admin/title/title.component';
import { CardComponent } from './card/card.component';
import { CardToggleDirective } from './card/card-toggle.directive';
import { ModalBasicComponent } from './modal-basic/modal-basic.component';
import { ModalAnimationComponent } from './modal-animation/modal-animation.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { NgxLoadingModule } from 'ngx-loading';
import { LoadingComponent } from './loding/loading.component';
import { LoadingService } from '../../services/loading.service';
import { FormHelpTextComponent } from './form-help-text/form-help-text.component';
import { NumberDirective } from '../../directives/only-numbers.directive';
import { FormContromHelpTextDirective } from '../../directives/form-controm-help-text.directive';
import { SuitabilityControlDirective } from '../../directives/suitability-control.directive';
import { SuitabilityQuestionComponent } from './suitability/suitability-question/suitability-question.component';
import { RadioQuestionComponent } from './suitability/suitability-question/radio-question/radio-question.component';
import { SuitabilityThermometerComponent } from './suitability/suitability-thermometer/suitability-thermometer.component';
import { TextQuestionComponent } from './suitability/suitability-question/text-question/text-question.component';
import { CurrencyMaskModule } from 'ngx-currency-mask';
import { CurrencyProvider } from '../../abstration/currency-config';
import { MultiTextQuestionComponent } from './suitability/suitability-question/multi-text-question/multi-text-question.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TextAnswerComponent } from './suitability/suitability-question/multi-text-question/text-answer/text-answer.component';
import { MultiRadioQuestionComponent } from './suitability/suitability-question/multi-radio-question/multi-radio-question.component';
import { VxFormatPipe } from '../../pipes/vx-format.pipe';
import { DocumentsListComponent } from './documents-list/documents-list.component';
import { ImageViewerModule } from 'ngx-image-viewer';
import { NgxDocViewerModule, NgxDocViewerComponent } from 'ngx-doc-viewer';
import { ControlInactiveDirective } from '../../directives/control-inactive.directive';
import { FilterJsonPipe } from '../../pipes/filter-json.pipe';
import { CountJsonPipe } from '../../pipes/count-json.pipe';
import { CountJsonFilterPipe } from '../../pipes/count-filter-json.pipe';
import { FilterFilesPipe } from '../../pipes/files-filter.pipe';
import { TagInputModule } from 'ngx-chips';
import { CardEditableListDocumentsComponent } from './card-editable-list-documents/card-editable-list-documents.component';
import { DxDateBoxModule } from 'devextreme-angular';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { FileUploadModule } from 'ng2-file-upload';
import { RepresentativeFormComponent } from './representative-form/representative-form.component';
import { NgxMaskModule } from 'ngx-mask';
import { DateComponent } from './date/date.component';
import { MultipleEmailComponent } from './multiple-email/multiple-email.component';
import { CountdownComponent } from './countdown/countdown.component';
import { CompanyBasicDataComponent } from './company-basic-data/company-basic-data.component';
import { InvestorCompanyInvestorDataFormGroup } from '../company/register/investor-data/forms/investor-company.form-group';
import { InvestmentFundInvestorDataFormGroup } from '../company/register/investor-data/forms/investment-fund-form-group';
import { ManagerInvestorDataFormGroup } from '../company/register/investor-data/forms/manager.form-group';
import { PeopleFormComponent } from './people-form/people-form.component';
import { RxFormBuilder } from '@rxweb/reactive-form-validators';
import { InvestorFundModel } from '../company/register/investor-data/personas/investor-fund.model';
import { RepresentativesData } from '../../models/agents/representatives-data';
import { IssuerModel } from '../company/register/investor-representatives-data/personas/issuer.model';
import { InvestmentFundRepresentativesDataModel } from './representative-form/personas/investment-fund-representative.model';
import { InvestorCompanyRepresentativesDataModel } from './representative-form/personas/investor-company-representative.model';
import { IssuerRepresentativesDataModel } from './representative-form/personas/issuer-representative.model';
import { ManagerRepresentativesDataModel } from './representative-form/personas/manager-representative.model';
import { InformationTooltipComponent } from './information-tooltip/information-tooltip.component';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { NgSelectModule } from '@ng-select/ng-select';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  imports: [
    CommonModule,
    NgbModule.forRoot(),
    NgxMaskModule.forRoot(),
    PerfectScrollbarModule,
    ClickOutsideModule,
    ImageViewerModule.forRoot(),
    NgxDocViewerModule,
    NgxLoadingModule.forRoot({}),
    ReactiveFormsModule,
    CurrencyMaskModule,
    TagInputModule,
    FormsModule,
    DxDateBoxModule,
    FileUploadModule,
    TagInputModule,
    NgSelectModule
  ],
  exports: [
    NgbModule,
    ImageViewerModule,
    NgxDocViewerModule,
    NgxDocViewerComponent,
    CurrencyMaskModule,
    ControlInactiveDirective,
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    CardToggleDirective,
    PerfectScrollbarModule,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    ClickOutsideModule,
    LoadingComponent,
    FormHelpTextComponent,
    SuitabilityThermometerComponent,
    NumberDirective,
    FormContromHelpTextDirective,
    SuitabilityControlDirective,
    SuitabilityQuestionComponent,
    RadioQuestionComponent,
    TextQuestionComponent,
    MultiTextQuestionComponent,
    TextAnswerComponent,
    MultiRadioQuestionComponent,
    VxFormatPipe,
    FilterJsonPipe,
    CountJsonFilterPipe,
    CountJsonPipe,
    DocumentsListComponent,
    CardEditableListDocumentsComponent,
    FileUploaderComponent,
    RepresentativeFormComponent,
    DateComponent,
    MultipleEmailComponent,
    CountdownComponent,
    PeopleFormComponent,
    CompanyBasicDataComponent,
    InformationTooltipComponent,
    ToggleSwitchComponent
  ],
  declarations: [
    ToggleFullScreenDirective,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    ControlInactiveDirective,
    AccordionDirective,
    CardToggleDirective,
    TitleComponent,
    CardComponent,
    ModalBasicComponent,
    ModalAnimationComponent,
    SpinnerComponent,
    LoadingComponent,
    FormHelpTextComponent,
    SuitabilityThermometerComponent,
    NumberDirective,
    FormContromHelpTextDirective,
    SuitabilityControlDirective,
    SuitabilityQuestionComponent,
    RadioQuestionComponent,
    TextQuestionComponent,
    MultiTextQuestionComponent,
    TextAnswerComponent,
    MultiRadioQuestionComponent,
    VxFormatPipe,
    FilterJsonPipe,
    CountJsonFilterPipe,
    CountJsonPipe,
    DocumentsListComponent,
    FilterFilesPipe,
    CardEditableListDocumentsComponent,
    FileUploaderComponent,
    RepresentativeFormComponent,
    DateComponent,
    MultipleEmailComponent,
    CountdownComponent,
    PeopleFormComponent,
    CompanyBasicDataComponent,
    InformationTooltipComponent,
    ToggleSwitchComponent
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    LoadingService,
    RxFormBuilder,
    InvestorFundModel,
    IssuerModel,
    CurrencyProvider,
    InvestorCompanyInvestorDataFormGroup,
    InvestmentFundInvestorDataFormGroup,
    ManagerInvestorDataFormGroup,
    RepresentativesData,
    InvestmentFundRepresentativesDataModel,
    InvestorCompanyRepresentativesDataModel,
    IssuerRepresentativesDataModel,
    ManagerRepresentativesDataModel
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedModule {}
